import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import useLang from "../../../hooks/useLang";
const Collections = () => {
    const { t } = useTranslation();
    const storeFrontData = useSelector((state) => state.app.storeData);
    const collections = storeFrontData.collections;
    const lang = useLang();
    return (
        <div className="p-2">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 place-items-center">
                <div className="grid place-items-center">
                    <div>
                        <div className="px-6 pt-4 pb-2">
                            <div className="font-bold text-5xl mb-2 text-black">{t('collections_heading')}</div>
                            <p className="text-gray-700 lg:text-lg text-base py-4">
                                {t('collections_text')}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="w-full sm:w-full md:w-full lg:w-8/12 p-2" style={{ direction: 'ltr' }}>
                    <Carousel
                        infiniteLoop={true}
                        autoPlay={true}
                        showThumbs={false}
                        showArrows={false}
                        showStatus={false}
                        renderIndicator={(onClick, isActive, index, label) => {
                            return (
                                <button className={isActive ? "active-mini-slide-indicator" : "mini-slide-indicator"}
                                    onClick={onClick}
                                ></button>
                            );
                        }}
                    >
                        {
                            collections.map((collection) => {
                                return (
                                    <div className="rounded overflow-hidden shadow-lg" key={collection.id}>
                                        <img className="max-w-full" src={collection.image}
                                            alt={collection.name}
                                        />
                                        <div className="legend">
                                            <div className="flex justify-between items-center">
                                                <div>
                                                    <h4 className="text-bold text-xl text-black">{collection.name}</h4>
                                                </div>
                                                <Link
                                                    to={"/shop/collection/" + collection.id + "/" + (lang === "en" ? collection.name : collection.name_ar)}

                                                    className="text-black">
                                                    <span
                                                        style={{
                                                            fontSize: 17
                                                        }}
                                                    >{t('see_all')}</span>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </Carousel>
                </div>
            </div>
        </div>

    );
}
export default Collections;